import { IStateWebSocket } from '../../entity/StateEntity';
import { WSMessageType } from 'src/services/WebSocketService';

const initialState: IStateWebSocket = {
  type: WSMessageType.初始状态,
  accountApprove: 0,
  accountConfigure: 0,
  order: 0,
  hasNewOrder: false,
  order_id: '',
};

export const webSocketState = (state: IStateWebSocket = initialState, action: IStateWebSocket): IStateWebSocket => {
  switch (action.type) {
    case WSMessageType.初始状态:
      return initialState;
    case WSMessageType.获取待审核医生:
      return Object.assign({}, state, {
        type: action.type,
        accountApprove: action.accountApprove,
        // accountConfigure: action.accountConfigure,
        // order: action.order,
        hasNewOrder: action.hasNewOrder,
      });
    case WSMessageType.获取待配置医生:
      return Object.assign({}, state, {
        type: action.type,
        // accountApprove: action.accountApprove,
        accountConfigure: action.accountConfigure,
        // order: action.order,
        hasNewOrder: action.hasNewOrder,
      });
    case WSMessageType.获取待处理订单:
      return Object.assign({}, state, {
        type: action.type,
        // accountApprove: action.accountApprove,
        // accountConfigure: action.accountConfigure,
        order: action.order,
        hasNewOrder: action.hasNewOrder,
      });
    case WSMessageType.发送药品清单结果:
      return Object.assign({}, state, {
        type: action.type,
        order_id: action.order_id,
      })
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/webSocketState.ts